interface MapParkinglotQsParams {
  parkinglotType: string
  parkinglotSeq: number
  lat: number
  lng: number
}

type ScreenName = 'summary' | 'parkinglotdetail' | 'ticketdetail' | 'myticketdetail' | ''

export const getMapParkinglotURL = (params: MapParkinglotQsParams, screenName: ScreenName) => {
  const host = 'https://l.modu.kr'
  const path = '/maps'

  const encodedParams = Object.keys(params).reduce((acc, currentValue) => {
    const key = currentValue as keyof MapParkinglotQsParams
    const value = params[key]
    if (!value) return acc
    return {
      ...acc,
      [currentValue]: encodeURIComponent(value)
    }
  }, {})
  const newParams = new URLSearchParams(encodedParams)
  const shortenURL = encodeURIComponent(
    `${host}${path}?${newParams.toString()}&${makeUtmTagWhenAppDownClick(screenName)}`
  )

  const qs = {
    apn: 'com.parkingshare.mobile',
    isi: '780174422',
    ibi: 'com.parkingshare.parkingshare'
  }
  const newQs = new URLSearchParams(qs)

  return `${host}?link=${shortenURL}&${newQs.toString()}`
}

export const makeUtmTagWhenAppDownClick = (screenName: ScreenName) => {
  return `utm_source=webapp&utm_medium=${screenName}&utm_campaign=appdownload`
}
